import { useQuery } from '@apollo/client';
import { ItemConnectionSort } from '../graphql/types';
import {
  ItemFilter,
  ItemScopeEnum,
  ItemSort,
  SearchItemsQuery,
  SearchItemsQueryVariables,
  SearchVippedAllQuery,
  SearchVippedAllQueryVariables
} from '../graphql/graphql';
import { searchItemsQuery, searchVippedAllQuery } from '../api/queries';
import { TransformedObj } from '../components/GeneralAdsPage/types';

export const getSearchResultInitialQueryParams = (
  filter: ItemFilter,
  sorting: ItemConnectionSort
): {
  itemsQueryVariables: SearchItemsQueryVariables;
  vipAllQueryVariables: SearchVippedAllQueryVariables;
} => {
  const itemsQueryVariables = {
    first: 16,
    filter,
    sort: sorting || ItemConnectionSort.BumpedAtDesc
  } as SearchItemsQueryVariables;

  const vipAllQueryVariables = {
    vipLimit: 8,
    vipFilter: { ...filter, scope: ItemScopeEnum.VippedPure },
    residenceLimit: 4,
    residenceFilter: { ...filter, scope: ItemScopeEnum.VippedApartments },
    sort: ItemSort.Random
  };

  return {
    itemsQueryVariables,
    vipAllQueryVariables
  };
};

export const useSearchResultItems = ({
  isItemsAllPage,
  transformedObj: { sorting, filter }
}: {
  isItemsAllPage: boolean | undefined;
  transformedObj: TransformedObj;
}) => {
  const { itemsQueryVariables, vipAllQueryVariables } =
    getSearchResultInitialQueryParams(filter, sorting);

  const vipAllQuery = useQuery<SearchVippedAllQuery>(searchVippedAllQuery, {
    variables: vipAllQueryVariables,
    notifyOnNetworkStatusChange: true,
    skip: isItemsAllPage
  });

  const searchQuery = useQuery<SearchItemsQuery>(searchItemsQuery, {
    variables: itemsQueryVariables,
    notifyOnNetworkStatusChange: true
  });

  const refetchAllSearchQueries = async () => {
    await searchQuery.refetch();
    if (!isItemsAllPage) await vipAllQuery.refetch();
  };

  return {
    hasError: !!searchQuery.error || !!vipAllQuery.error,
    vipAllQuery,
    searchQuery,
    refetchAllSearchQueries
  };
};
